<template>
  <div>
    <RevButton
      class="mb-36"
      :icon="IconChevronLeft"
      size="small"
      variant="secondary"
      @click="handleGoBack"
    >
      {{ i18n(translations.goBackButton) }}
    </RevButton>
    <h1 class="heading-1 mb-24">{{ i18n(translations.title) }}</h1>
    <p class="body-1 mb-32">{{ i18n(translations.description) }}</p>
    <Summary :is-editable="stepIsEditable" />
    <div class="mx-auto mt-48 w-[328px]">
      <RevButton
        class="w-full"
        :disabled="isSubmitting || !stepIsEditable"
        :loading="isSubmitting"
        variant="primary"
        @click="handleSubmit"
      >
        {{ i18n(translations.submitButton) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { navigateTo, useHead } from '#imports'
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'

import { ROUTE_NAMES } from '~/constants/routes'
import { useKybData } from '~/scopes/kyb/composables/useKybData'
import { useKybNavigation } from '~/scopes/kyb/composables/useKybNavigation'

import { CURRENT_STEP } from './Review.constants'
import translations from './Review.translations'
import Summary from './components/Summary.vue'

const i18n = useI18n()
useHead({ title: i18n(translations.pageTitle) })
const { openSuccessToast, openErrorToast } = useTheToast()
const {
  submitKyb,
  workflow: { isStepEditable },
} = useKybData()
const { handleGoBack } = useKybNavigation()

const stepIsEditable = computed(() => isStepEditable(CURRENT_STEP))
const isSubmitting = ref(false)

async function handleSubmit() {
  isSubmitting.value = true

  try {
    await submitKyb()

    openSuccessToast({
      title: i18n(translations.submitSuccessTitle),
      content: i18n(translations.submitSuccessContent),
    })

    navigateTo({ name: ROUTE_NAMES.ONBOARDING.HOME })
  } catch (error) {
    openErrorToast({
      title: i18n(translations.submitErrorTitle),
      content: i18n(translations.submitErrorContent),
    })
  } finally {
    isSubmitting.value = false
  }
}
</script>
